import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { count: Number, source: String }

  connect() {
    this.updateConfirmation()
  }

  updateConfirmation() {
    const target = this.selectTarget.selectedOptions[0]?.textContent.trim()
    if (!target) return

    const noun = this.countValue === 1 ? "document" : "documents"
    this.element.dataset.turboConfirm =
      `Move ${this.countValue} ${noun} from ${this.sourceValue} to ${target}?`
  }
}
